import React from "react";
import classNames from "classnames";
import "./FullWidthSection.scss";
import { withDefaults } from "../../utils/withDefaults";

export interface FullWidthSectionProps {
  hasDarkBackground?: boolean;
  hasLargePadding?: boolean;
  sectionId?: string;
  children?: React.ReactNode;
}

export default function FullWidthSection(incomingProps: FullWidthSectionProps) {
  const props = withDefaults(incomingProps, fullWidthSectionDefaultProps);

  return (
    <div
      className={classNames(
        "full-width-section",
        props.hasDarkBackground ? "dark-background" : null,
        props.hasLargePadding ? "large-padding" : null
      )}
      id={props.sectionId}
    >
      {props.children}
    </div>
  );
}

const fullWidthSectionDefaultProps = {
  hasDarkBackground: false,
  hasLargePadding: false,
};
